import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" role="contentinfo" aria-label="Site Footer" className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <div className="flex flex-col">
                <span className="font-outfit font-bold text-2xl">
                  <span className="text-cyan-400">elc</span>
                  <span className="text-white">teknoloji</span>
                </span>
                <span className="text-xs text-slate-400 tracking-wider">OT&IT Cybersecurity Solutions</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-md">
              {t('footer.description')}
            </p>
            <p className="text-slate-400 text-sm">
              ELC Teknoloji San ve Tic Ltd Şti
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-outfit font-semibold text-white mb-6">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/profesyonel-hizmetler" data-testid="footer-link-professional-services"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.professionalServices')}
                </Link>
              </li>
              <li>
                <Link to="/cozumler" data-testid="footer-link-solutions"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.solutions')}
                </Link>
              </li>
              <li>
                <Link to="/guvenlik-urunleri" data-testid="footer-link-security"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.securityProducts')}
                </Link>
              </li>
              <li>
                <Link to="/zebra-urunleri" data-testid="footer-link-zebra"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.zebraProducts')}
                </Link>
              </li>
              <li>
                <Link to="/iletisim" data-testid="footer-link-contact"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-outfit font-semibold text-white mb-6">{t('footer.legal')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/gizlilik" data-testid="footer-link-privacy"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/kullanim-kosullari" data-testid="footer-link-terms"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('footer.terms')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-outfit font-semibold text-white mb-6">{t('footer.contactTitle')}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-cyan-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@elcteknoloji.com" data-testid="footer-email"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  info@elcteknoloji.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-cyan-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+905322705174" data-testid="footer-phone"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  +90 532 270 51 74
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-cyan-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">{t('footer.country')}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">
            &copy; {new Date().getFullYear()} ELC Teknoloji. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/gizlilik" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
              {t('footer.privacy')}
            </Link>
            <Link to="/kullanim-kosullari" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
              {t('footer.terms')}
            </Link>
            <a href="https://www.elcteknoloji.com" target="_blank" rel="noopener noreferrer"
              data-testid="footer-website" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
              www.elcteknoloji.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
